import { useEffect } from "react";
import { useRefinementList } from "react-instantsearch";

/**
 * 커스텀 위젯: facet 하나를 URL 쿼리 파라미터와 동기화한다.
 *
 * facetFilters 를 직접 넘기지 않고 useRefinementList(connectRefinementList) 를 쓰는 이유는,
 * 이렇게 해야 disjunctive faceting 이 적용돼서 "브랜드 A 선택 후에도 브랜드 B 의 개수가 남아 있는"
 * 기존 Shopify 필터 동작이 그대로 유지되기 때문이다.
 */
export default function useSyncedFacet(attribute: string, selected: string[]) {
  const { items, refine } = useRefinementList({ attribute, limit: 200, sortBy: ["name:asc"], operator: "or" });

  const selectedKey = [...selected].sort().join(",");

  // items 는 렌더마다 새 배열이므로, 실제로 적용된 값만 뽑아 안정적인 키로 만든다.
  const refinedKey = items
    .filter((item) => item.isRefined)
    .map((item) => item.value)
    .sort()
    .join(",");

  useEffect(() => {
    const refined = new Set(refinedKey ? refinedKey.split(",") : []);
    const desired = new Set(selected);

    desired.forEach((value) => {
      if (!refined.has(value)) refine(value);
    });

    refined.forEach((value) => {
      if (!desired.has(value)) refine(value);
    });
  }, [selectedKey, refinedKey]);

  return items;
}
